import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();
  
  return (
    <div className="navigation">
      {[1, 2, 3, 4, 5].map(page => (
        <Link
          key={page}
          to={`/${page}`}
          style={{
            backgroundColor: location.pathname === `/${page}` ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.7)',
            color: 'white',
            textDecoration: 'none',
            fontFamily: 'Frijole, system-ui',
            fontSize: '1.2rem',
            marginRight: '10px',
            padding: '10px 15px',
            borderRadius: '5px',
            transition: 'background-color 0.3s'
          }}
        >
          {page}
        </Link>
      ))}
    </div>
  );
};

export default Navigation;
